/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse403,
    InlineResponse403FromJSON,
    InlineResponse403ToJSON,
    UserVoucher,
    UserVoucherFromJSON,
    UserVoucherToJSON,
    UserVoucherDataFrame,
    UserVoucherDataFrameFromJSON,
    UserVoucherDataFrameToJSON,
} from '../models';

export interface ApiUserVouchersGetRequest {
    relations?: string;
    deleted?: boolean;
    filtering?: string;
    offset?: number;
    limit?: number;
    order?: string;
}

export interface ApiUserVouchersIdDeleteRequest {
    id: number;
}

export interface ApiUserVouchersIdGetRequest {
    id: number;
    relations?: string;
    deleted?: boolean;
}

export interface ApiUserVouchersPostRequest {
    relations?: string;
    deleted?: boolean;
    userVoucher?: UserVoucher;
}

/**
 * no description
 */
export class UserVoucherApi extends runtime.BaseAPI {

    /**
     * Get list of UserVoucher
     */
    async apiUserVouchersGetRaw(requestParameters: ApiUserVouchersGetRequest): Promise<runtime.ApiResponse<UserVoucherDataFrame>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        if (requestParameters.filtering !== undefined) {
            queryParameters['filtering'] = requestParameters.filtering;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userVouchers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserVoucherDataFrameFromJSON(jsonValue));
    }

    /**
     * Get list of UserVoucher
     */
    async apiUserVouchersGet(relations?: string, deleted?: boolean, filtering?: string, offset?: number, limit?: number, order?: string): Promise<UserVoucherDataFrame> {
        const response = await this.apiUserVouchersGetRaw({ relations: relations, deleted: deleted, filtering: filtering, offset: offset, limit: limit, order: order });
        return await response.value();
    }

    /**
     * Remove entity of UserVoucher
     */
    async apiUserVouchersIdDeleteRaw(requestParameters: ApiUserVouchersIdDeleteRequest): Promise<runtime.ApiResponse<UserVoucher>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserVouchersIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userVouchers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserVoucherFromJSON(jsonValue));
    }

    /**
     * Remove entity of UserVoucher
     */
    async apiUserVouchersIdDelete(id: number): Promise<UserVoucher> {
        const response = await this.apiUserVouchersIdDeleteRaw({ id: id });
        return await response.value();
    }

    /**
     * Get entity of UserVoucher
     */
    async apiUserVouchersIdGetRaw(requestParameters: ApiUserVouchersIdGetRequest): Promise<runtime.ApiResponse<UserVoucher>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserVouchersIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userVouchers/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserVoucherFromJSON(jsonValue));
    }

    /**
     * Get entity of UserVoucher
     */
    async apiUserVouchersIdGet(id: number, relations?: string, deleted?: boolean): Promise<UserVoucher> {
        const response = await this.apiUserVouchersIdGetRaw({ id: id, relations: relations, deleted: deleted });
        return await response.value();
    }

    /**
     * Create or update entity of UserVoucher (if id defined)
     */
    async apiUserVouchersPostRaw(requestParameters: ApiUserVouchersPostRequest): Promise<runtime.ApiResponse<UserVoucher>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.relations !== undefined) {
            queryParameters['relations'] = requestParameters.relations;
        }

        if (requestParameters.deleted !== undefined) {
            queryParameters['deleted'] = requestParameters.deleted;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/userVouchers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserVoucherToJSON(requestParameters.userVoucher),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserVoucherFromJSON(jsonValue));
    }

    /**
     * Create or update entity of UserVoucher (if id defined)
     */
    async apiUserVouchersPost(relations?: string, deleted?: boolean, userVoucher?: UserVoucher): Promise<UserVoucher> {
        const response = await this.apiUserVouchersPostRaw({ relations: relations, deleted: deleted, userVoucher: userVoucher });
        return await response.value();
    }

}
